import React from 'react';
import styled from 'styled-components';
import { theme } from 'styles/theme';

interface ISlider {
  id?: string;
  label: string;
  value: number;
  min?: number;
  max?: number;
  step?: number;
  onChange: (value: number) => void;
}

const Slider: React.FC<ISlider> = ({
  id = 'workplace',
  label,
  value,
  min = 0,
  max = 1000,
  step = 1,
  onChange,
  ...props
}) => {
  const handleSliderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = Math.round(parseInt(event.target.value, 10) / step) * step;
    onChange(value);
  };

  const adjustedValue = Math.min(Math.max(value, min), max);

  const displayValue = adjustedValue >= max ? `ca ${max}+ m²` : `ca ${adjustedValue} m²`;
  const employeesValue = adjustedValue >= max ? `ca ${max}+ st` : `ca ${adjustedValue} st`;

  const setDisplayValue = () => {
    if (id === 'workplace') {
      return displayValue;
    }

    if (id === 'employees') {
      return employeesValue;
    }

    return '';
  };

  return (
    <Wrapper {...props}>
      <Label>{label}</Label>
      <SliderInput
        type="range"
        min={min}
        max={max}
        step={step}
        value={adjustedValue}
        onChange={handleSliderChange}
        aria-labelledby={id}
      />
      <ValueLabel>{setDisplayValue()}</ValueLabel>
    </Wrapper>
  );
};

export default Slider;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;

  border-radius: ${theme.dimensions.components.borderRadius};
  background-color: #fff9f3;
  padding: 2rem 3rem 1.5rem;
`;

const SliderInput = styled.input`
  -webkit-appearance: none;
  height: 3px;
  background: rgba(0, 0, 0, 10%);
  border-radius: 9px;
  outline: none;
  margin: 0;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 30px;
    height: 30px;
    background: ${theme.colors.remondis_accent};
    border-radius: 50%;
    cursor: pointer;
  }

  &::-moz-range-thumb {
    width: 30px;
    height: 30px;
    background: ${theme.colors.remondis_accent};
    border-radius: 50%;
    cursor: pointer;
  }
`;

const Label = styled.p`
  font-family: var(--secondary-font);
  font-size: 18px;
  text-align: center;
  margin: 0 0 45px 0;
  line-height: 1;
`;

const ValueLabel = styled.h4`
  margin: 18px 0 0 0;
`;
